export var apiurl = 'https://backend.getanycars.com/';
//export var apiurl = 'http://127.0.0.1:8000/';
export var imgurl = 'https://backend.getanycars.com';
